<div class="container">
  <label for="aor-sel">{{ 'CRM.LABEL.AOR' | translate }}: </label>
  @if (!isLoading) {
    <p-multiSelect
      inputId="aor-sel"
      [options]="aors()"
      optionLabel="name"
      [(ngModel)]="selectedAORs"
      placeholder="{{ 'CRM.LABEL.CHOOSE_AOR' | translate }}"
      (onChange)="aorSelectionChanged($event)"
      [disabled]="isDisabled()"
      autoWidth="false"
      class="dropdown"
    />
  }
  <div class="spin-container">
    @if (isLoading) {
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" />
    }
  </div>
</div>
